import { useContext } from 'react';
import { ReminderContext } from './ReminderContext';
export var useReminder = function () {
    return useContext(ReminderContext);
};
